import get from 'lodash/get'

import { logSearchError } from '../../../util/clientLogger'
import { getFlexDates } from '../../../services/flexDates/flexDatesApi'
import {
  _shouldCallElasticSearch,
  _handleRetailFlexDatesResponse,
  _handleSOPQElasticResponse,
  generateFlexDatesQuery,
} from '../helpers'

import {
  setRetailFlexDates,
  setExdFlexDates,
  setCurrentlyViewing,
} from '../flexDatesActionCreators'
import { calculateAdvancePurchaseWindow } from '../../../util/calculate-advance-purchase-window'
import { fireFlyConditions } from '../../../constants/fireflyCondition'

export function fetchFlexDates(
  requestObj,
  tripType = 'RT',
  sopqEnabled = true
) {
  return dispatch => {
    // requestObj = PCLN Search Request

    /**
     * NOTE as of Oct 25:
     * We're suppressing flex dates on FF as it's not supported yet
     * Once supported, remove the !fireFlyConditions.isFireFly() condition
     */
    if (!fireFlyConditions.isFireFly()) {
      const departDate = get(requestObj, 'slices[0].travelDate')
      const apWindow = departDate && calculateAdvancePurchaseWindow(departDate)

      const isOW = tripType === 'OW'
      const isMD = tripType === 'MD'
      const isRT = tripType === 'RT'

      if (_shouldCallElasticSearch(apWindow, isRT) && !isMD) {
        let retailRangePlusMinus = isOW ? 2 : 3
        if (
          isOW &&
          apWindow === 0 // departDate is Today
        ) {
          retailRangePlusMinus = 3
        }
        const { query, passengerUrl } = generateFlexDatesQuery({
          requestObj,
          tripType,
          rangePlusMinus: retailRangePlusMinus,
        })

        getFlexDates({ request: query, tripType })
          .then(res => {
            const response = _handleRetailFlexDatesResponse(
              res,
              query.trips,
              passengerUrl,
              requestObj,
              isOW
            )

            dispatch(setRetailFlexDates(response.calendarPricing))
            dispatch(setCurrentlyViewing(response.currentlyViewing))
          })
          .catch(err => {
            logSearchError('Flex Dates Retail Error response', err)
          })

        if (sopqEnabled) {
          const sopqRangePlusMinus = 7
          const {
            query: exdQuery,
            passengerUrl: exdPassengerUrl,
          } = generateFlexDatesQuery({
            requestObj,
            tripType,
            rangePlusMinus: sopqRangePlusMinus,
          })

          const sopqQuery = exdQuery
          const sopqPassengerUrl = exdPassengerUrl

          sopqQuery.sopq = true
          getFlexDates({ request: sopqQuery, tripType })
            .then(res => {
              const response = _handleSOPQElasticResponse(
                res,
                sopqQuery.trips,
                sopqPassengerUrl,
                requestObj
              )
              dispatch(setExdFlexDates(response))
            })
            .catch(err => {
              logSearchError('Flex Dates Express Deal Error response', err)
            })
        }
      }
    }
  }
}
